import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const columns = (
  lang: string,
  handleDelete: any,
  warehouseList: any
) => {
  return [
    {
      title: "Number",
      dataIndex: "number",
      key: "number",
    },
    {
      title: lang === "en-US" ? "email" : "ایمیل",
      dataIndex: "email",
      key: "email",
    },
    {
      title: lang === "en-US" ? "userId" : "شماره کاربر",
      dataIndex: "userId",
      key: "userId",
    },
    {
      title: lang === "en-US" ? "warehouse name" : "نام انبار",
      dataIndex: "warehouseName",
      key: "warehouseName",
      render: (source: number) => (
        <>
          {warehouseList.find((warehouse: any) => warehouse.id === source)
            ? warehouseList.find((warehouse: any) => warehouse.id === source)
                .name
            : "--"}
        </>
      ),
    },
    {
      title: lang === "en-US" ? "Delete" : "حذف ",
      dataIndex: "Delete",
      key: "Delete",
      render: (source: any) => (
        <>
          <Button
            style={{ border: "none" }}
            onClick={() => handleDelete(source)}
          >
            <DeleteOutlined style={{ fontSize: "22px", color: "#d82148" }} />
          </Button>
        </>
      ),
    },
  ];
};
export const datahelper = (res: any, page: number) => {
  const newData = res.map((item: any, index: number) => {
    return {
      ...item,
      key: item.id,
      number: index + 1 + 40 * (page - 1),
      Delete: item,
      warehouseName: item.warehouseId,
    };
  });
  return newData;
};
